import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ILocationService, LocationItem, LocationsRequest } from '../common';
import { ApiMethodConstants } from '../common/api-method.constants';
import { ApiBuilder } from '../common/api-url-builder';

@Injectable()
export class ImmigrantLocationsService implements ILocationService {
  constructor(
    private httpClient: HttpClient,
    private apiBuilder: ApiBuilder
  ) {}

  public getLocations(request: LocationsRequest): Promise<LocationItem[]> {
    const url = this.apiBuilder.buildUrl(request, ApiMethodConstants.Mshs);
    const headers = new HttpHeaders({
      Accept: '*/*'
    });

    return this.httpClient
      .get(url, { headers: headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('Error getting name suggestions from a name suggestion service.');
    return Promise.reject(error.message || error);
  }
}
